export default __webpack_public_path__ + "static/media/fb.43e2b6f2.svg";